import { Typography } from '@mui/material';
import CreditNotesTable from 'components/CreditNotesTable';
import ReceiptsTable from 'components/ReceiptsTable';

export default function ReceiptsAndCreditNotesScreen() {
  return (
    <>
      <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
        Recibos
      </Typography>
      <Typography variant='body2' sx={{ mb: 2 }}>
        Los pagos se procesan de forma manual, por lo que pueden tardar hasta 48 horas hábiles en verse reflejados en el sistema.
      </Typography>
      <ReceiptsTable />
      <Typography variant='h6' sx={{ mt: 2, mb: 1 }}>
        Notas de crédito
      </Typography>
      <Typography variant='body2' sx={{ mb: 1 }}>
        Las notas de crédito son generadas automáticamente si para cierto período de facturación el monto a recuperar por tu tienda es mayor
        a la comisión a pagar.
      </Typography>
      <Typography variant='body2' sx={{ mb: 2 }}>
        Son descontadas automáticamente de tus próximas facturas y tomadas en cuenta en tu balance total.
      </Typography>
      <CreditNotesTable />
    </>
  );
}
